/*
 * General custom scripts
 */
/**
 * Top header - mobile menu Button
 */
import { Header } from "./front/Header";
new Header( ".js-navigation" );


/**
 * Scroll up b
 *
 */
import { ScrollUp } from './front/ScrollUp';
new ScrollUp( );

/**
 * Scroll to Anchor
 */
import { ScrollToAnchor } from './front/ScrollToAnchor';
new ScrollToAnchor( 150 );

/**
 * Contact form 7 tools, spam prevention
 */
import { ContactForm7Tools } from './front/ContactForm7Tools';
new ContactForm7Tools();
